import React from 'react';
import './blog-post.css';

import ttd1 from './pictures/ttd1.png';
import ttd2 from './pictures/ttd2.png';
import ttd3 from './pictures/ttd3.png';
import ttd4 from './pictures/ttd4.png';

const Thetradedesk = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>Prepare for Summer and Fall with The Trade Desk Recap</h2>
                    <p class="site-post-meta">May 16th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Thursday, on May 16th, WiC hosted our ‘Preparing for the Summer and Fall’ event with The Trade Desk! 
                    We had WiC members and other Allen School students come together to meet Jeremy, who is leading the 
                    University Recruiting team at The Trade Desk. Attendees enjoyed some yummy banh mi from Vinason Pho 
                    as we heard his insights into tech recruiting and worked through some interview exercises as a group. 
                    Thank you to everyone who came out to engage with The Trade Desk and WiC! 
                    <br></br>
                     
                    </p>
                    <img src={ttd1} alt="Group picture"/>
                    <img src={ttd2} alt="Group picture"/>
                    <img src={ttd3} alt="Banh mi"/>
                    <img src={ttd4} alt="Group picture"/>
                   
                
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Thetradedesk;

